import { Language, State } from './model';
import DefaultTranslations from './translations/appTranslations.json';
import { objectKeysToObject } from '../../utils';

export const AppKeys = objectKeysToObject(DefaultTranslations);
export const AppMessages: { [k: string]: string } = DefaultTranslations;
//export const AppKeys = objectKeysToObject(AppMessages);

export const Czech: Language = {
  code: 'cs-cz',
  folder: 'cs-CZ',
  name: 'Czech',
};

export const Danish: Language = {
  code: 'da-dk',
  folder: 'da-DK',
  name: 'Dansk',
};

export const German: Language = {
  code: 'de-de',
  folder: 'de-DE',
  name: 'German',
};

export const English: Language = {
  code: 'en-uk',
  folder: 'en-GB',
  name: 'English(GB)',
};

export const American: Language = {
  code: 'en-us',
  folder: 'en-US',
  name: 'English(US)',
};

export const Spanish: Language = {
  code: 'es-es',
  folder: 'es-ES',
  name: 'Castellano',
};

export const Finish: Language = {
  code: 'fi-fi',
  folder: 'fi-FI',
  name: 'Finish',
};

export const French: Language = {
  code: 'fr-fr',
  folder: 'fr-FR',
  name: 'French',
};

export const Dutch: Language = {
  code: 'nl-nl',
  folder: 'nl-NL',
  name: 'Dutch',
};

export const Norwegian: Language = {
  code: 'no-no',
  folder: 'no-NO',
  name: 'Norwegian',
};

export const Polish: Language = {
  code: 'pl-pl',
  folder: 'pl-PL',
  name: 'Polish',
};


export const Russian: Language = {
  code: 'ru-ru',
  folder: 'ru-RU',
  name: 'Russian',
};


export const Swedish: Language = {
  code: 'se-se',
  folder: 'sv-SE',
  name: 'Swedish',
};

export const Chinese: Language = {
  code: 'zh-cn',
  folder: 'zh-CN',
  name: 'Chinese',
};

export const Languages = [English, Danish, American, Spanish, Chinese, Czech, Dutch,Finish, French, German, Norwegian, Polish, Russian, Swedish];

export const DefaultLanguage: Language = English;

export const StateDefault: State = {
  lang: DefaultLanguage.folder,
};
